// extracted by mini-css-extract-plugin
export var secondaryHeading = "benefits-module--secondaryHeading--eKq4D";
export var content = "benefits-module--content--99oYV";
export var contentCard = "benefits-module--contentCard--HMHXa";
export var contentHeading = "benefits-module--contentHeading--ZB83V";
export var contentImage = "benefits-module--contentImage--frSSx";